import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    /**
     * Constructor
     */
    constructor(private _authService: AuthService, private _notifierService: NotifierService, private _router: Router) { }
    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Clone the request object
        let newReq = req.clone();

        // Request
        //
        // If the access token didn't expire, add the Authorization header.
        // We won't add the Authorization header if the access token expired.
        // This will force the server to return a "401 Unauthorized" response
        // for the protected API routes which our response interceptor will
        // catch and delete the access token from the local storage while logging
        // the user out from the app.
        if (this._authService.accessToken) {
            newReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + this._authService.accessToken)
            });
        }

        newReq = newReq.clone({
            headers: newReq.headers.set('sourceChannel', 'OPERATIONS_PORTAL'),
        });

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {
                if (error instanceof HttpErrorResponse) {

                    switch (error.status) {
                        case 401: //Unauthorized
                            // Sign out
                            this._authService.signOut();
                            this._router.navigate(['/auth/signin']);
                            // this._notifierService.notify('error', localStorage.getItem('language') === "en" ? error['error'].errorMsgEn : error['error'].errorMsgAr);
                            break;
                        case 404:
                            // sepicail handle of model bank
                            if (!error.message.includes('Authorized')) {
                                this._notifierService.notify('error', error['message']);
                            }
                            break;
                        case 428:
                        case 422:
                            break;
                        default:
                            this._notifierService.notify('error', localStorage.getItem('language') === "en" ? error['error'].errorMsgEn : error['error'].errorMsgAr);
                            break;
                    }
                }

                return throwError(() => error);
            })
        );
    }
}
